module.exports = __webpack_public_path__ + "img/Home_Bild3.448c3a27.jpg";